module.exports = __webpack_public_path__ + "static/media/18.e65d354f.png";